import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.scss']
})
export class UploadProgressComponent implements OnInit {


  @Input() listaArquivos = new Array<any>();
  constructor() { }

  ngOnInit(): void {
  }

  obterListaArquivos() {
    const lista = this.listaArquivos;
    for (const item of lista) {
      const ext = this.obterExtensaoArquivo(item.arquivo);
      item['fileExt'] = ext;
      item['colorIcon'] = this.intToRGB(this.hashCode(ext));
    }

    return lista;
  }

  obterExtensaoArquivo(fileName: string) {
    const partFileName = fileName.split('.');
    return partFileName[partFileName.length - 1].toUpperCase();
  }
  hashCode(str) { // java String#hashCode
    let hash = 1;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) * hash;
    }
    return hash;
  }

  intToRGB(i) {
    // tslint:disable-next-line: no-bitwise
    const c = (i & 0x00FFFFFF)
      .toString(16)
      .toUpperCase();

    return '#' + '00000'.substring(0, 6 - c.length) + c;
  }
}
